<section class="flex flex-col font-display">
<div class="flex flex-col gap-4 w-full mt-4 sm:flex-row sm:items-center sm:justify-between">
  <span class="font-semibold">Status</span>
  <div class="flex flex-col gap-2 w-full sm:w-auto sm:flex-row sm:items-center">
    <button
      [matMenuTriggerFor]="menu"
      class="px-4 py-2 text-sm font-semibold h-10 rounded-lg text-[#5C5C5C] border border-gray-300 flex items-center justify-center space-x-2 w-full sm:w-auto"
    >
      <i class="fa-solid fa-table-columns"></i>
      <span>Column</span>
    </button>
    <mat-menu #menu="matMenu" yPosition="below">
      <div class="flex flex-col space-y-2 pl-2 pr-4">
        @for (item of column; track $index) {
        <div class="flex items-center space-x-2">
          <mat-checkbox
            [(ngModel)]="item.active"
            (click)="checkColumn(); $event.stopPropagation()"
          ></mat-checkbox>
          <span class="font-display">{{ item.value }}</span>
        </div>
        }
      </div>
    </mat-menu>
    <input
      type="text"
      class="h-10 w-full sm:w-72 border border-gray-300 rounded-lg text-sm p-3 focus:outline-none"
      placeholder="Cari..."
      [formControl]="searchFormControl"
    />
    <button
      (click)="generateExcel()"
      class="px-4 py-2 text-sm font-semibold h-10 rounded-lg bg-[#42A5CE] text-white flex items-center justify-center space-x-2 w-full sm:w-auto"
    >
      Generate Excel
    </button>
  </div>
</div>
<div class="mt-6 px-1 py-1 overflow-x-auto overflow-y-visible">
  <div class="flex items-center gap-3 min-w-max">
  <button
    (click)="changeFilter(null)"
    [ngClass]="{ 'ring-2 ring-gray-500': currentFilter == null }"
    class="px-6 h-12 rounded-xl font-medium text-[#3e3e3e] bg-white border border-[#D4D4D4] flex items-center space-x-3 justify-center"
  >
    <span>All</span>
  </button>
  <button
    (click)="changeFilter('draft')"
    [ngClass]="{ 'ring-2 ring-gray-500': currentFilter == 'draft' }"
    class="px-6 h-12 rounded-xl font-medium text-white bg-[#D4D4D4] flex items-center space-x-3 justify-center"
  >
    <div
      class="rounded-full h-8 w-8 flex items-center justify-center bg-[#8C8C8C]"
    >
      {{ counter.draftCount }}
    </div>
    <span>Draft</span>
  </button>
  <button
    (click)="changeFilter('sent')"
    [ngClass]="{ 'ring-2 ring-gray-500': currentFilter == 'sent' }"
    class="px-6 h-12 rounded-xl font-medium text-white bg-[#FDCBAA] flex items-center space-x-3 justify-center"
  >
    <div
      class="rounded-full h-8 w-8 flex items-center justify-center bg-[#F68E17]"
    >
      {{ counter.sentCount }}
    </div>
    <span>Sent</span>
  </button>
  <button
    (click)="changeFilter('approved')"
    [ngClass]="{ 'ring-2 ring-gray-500': currentFilter == 'approved' }"
    class="px-6 h-12 rounded-xl font-medium text-white bg-[#AACAFD] flex items-center space-x-3 justify-center"
  >
    <div
      class="rounded-full h-8 w-8 flex items-center justify-center bg-[#5582C9]"
    >
      {{ counter.approvedCount }}
    </div>
    <span>Approved</span>
  </button>
  <button
    (click)="changeFilter('reimbursed')"
    [ngClass]="{ 'ring-2 ring-gray-500': currentFilter == 'reimbursed' }"
    class="px-6 h-12 rounded-xl font-medium text-white bg-[#85E2B1] flex items-center space-x-3 justify-center"
  >
    <div
      class="rounded-full h-8 w-8 flex items-center justify-center bg-[#3DB474]"
    >
      {{ counter.reimbursedCount }}
    </div>
    <span>Finished</span>
  </button>
  <button
    (click)="changeFilter('rejected')"
    [ngClass]="{ 'ring-2 ring-gray-500': currentFilter == 'rejected' }"
    class="px-6 h-12 rounded-xl font-medium text-white bg-[#FFE1E0] flex items-center space-x-3 justify-center"
  >
    <div
      class="rounded-full h-8 w-8 flex items-center justify-center bg-[#FF6A65]"
    >
      {{ counter.rejectedCount }}
    </div>
    <span>Rejected</span>
  </button>
  </div>
</div>
<div class="overflow-x-auto">
  <table mat-table
    [dataSource]="dataSource"
    class="mat-elevation-z0 mt-6 min-w-max w-full text-sm"
  >
    <ng-container matColumnDef="refId">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="!font-semibold text-sm sm:text-base whitespace-nowrap"
      >
        Ref ID
      </th>
      <td mat-cell *matCellDef="let element">
        <span
          class="px-2 py-1 rounded-md text-xs font-semibold bg-slate-100 text-slate-900"
          >{{ element.refId || '-' }}</span
        >
      </td>
    </ng-container>

    <ng-container matColumnDef="title">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="!font-semibold text-sm sm:text-base whitespace-nowrap"
      >
        Title
      </th>
      <td mat-cell *matCellDef="let element">{{ element.title || '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="type_data">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="!font-semibold text-sm sm:text-base whitespace-nowrap"
      >
        Type
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.type_data || '-' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="expanseCategory">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="!font-semibold text-sm sm:text-base whitespace-nowrap"
      >
        Expanse Category
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.expenseCategory?.name || '-' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="!font-semibold text-sm sm:text-base whitespace-nowrap"
      >
        Status
      </th>
      <td mat-cell *matCellDef="let element">
        <span
          class="px-2 py-1 rounded-md text-xs font-semibold"
          [ngClass]="getStatusClass(element.status)"
        >
          {{ element.status || '-' }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="date">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="!font-semibold text-sm sm:text-base whitespace-nowrap"
      >
        Date
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.startDate ? (element.startDate | date : "longDate" : "+0700") : "-" }}
        -
        {{ element.endDate ? (element.endDate | date : "longDate" : "+0700") : "-" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="amount">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="!font-semibold text-sm sm:text-base whitespace-nowrap"
      >
        Amount
      </th>
      <td mat-cell *matCellDef="let element" class="whitespace-nowrap">
        {{
          element.currency &&
          element.amount !== null &&
          element.amount !== undefined
            ? (element.currency + " " + (element.amount | number))
            : "-"
        }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">
        <div
            class="w-full flex flex-col items-center justify-center gap-2 py-6 text-center font-display"
          >
            <div
              class="flex h-10 w-10 items-center justify-center rounded-full bg-slate-100 text-slate-400"
            >
              <i class="fa-solid fa-inbox"></i>
            </div>
            <span class="text-sm font-semibold text-slate-700"
              >No data available</span
            >
            <span class="text-xs text-slate-500"
              >Try adjusting filters or search.</span
            >
          </div>
      </td>
    </tr>
  </table>
</div>
<mat-paginator
  [length]="dataTotal"
  [pageSize]="this.q.limit"
  [pageSizeOptions]="pageSizeOption"
  (page)="onPageChange($event)"
  aria-label="Select page"
>
</mat-paginator>
</section>
